import { GearSix } from "@phosphor-icons/react";
import clsx from "clsx";

import { ExcludeTargetsSettings } from "features/campaigns/components";

import { Button } from "common/components/ui/Button";
import {
  dropdownMenuContentVariants,
  dropdownMenuLabelClassname,
  dropdownMenuListVariants,
} from "common/components/ui/DropdownMenu";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "common/components/ui/Popover";

import { useCampaignContext } from "../../../context/CampaignContext";
import useCampaignMutations from "../../../datahooks/useCampaignMutations";

export default function ExcludeTargetsPopoverButton() {
  const {
    id: campaignId,
    exclude_active_targets,
    exclude_previous_targets,
    no_pfp,
    outreach_type,
  } = useCampaignContext();
  const { updateCampaign } = useCampaignMutations();

  const settings = { exclude_active_targets, exclude_previous_targets, no_pfp };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="secondary-black" intent="iconOnly" size="sm">
          <GearSix />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className={clsx(dropdownMenuContentVariants({ size: "md" }), "w-60")}
        align="end"
      >
        <div className={dropdownMenuListVariants({ size: "md" })}>
          <p className={dropdownMenuLabelClassname}>Exclude targets</p>
          <ExcludeTargetsSettings
            isDrip={outreach_type === "drip"}
            settings={settings}
            setSettings={(updates) => updateCampaign({ campaignId, updates })}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
}
